import { render } from "./noPatientInformation.vue?vue&type=template&id=2938ff05&scoped=true"
import script from "./noPatientInformation.vue?vue&type=script&lang=js"
export * from "./noPatientInformation.vue?vue&type=script&lang=js"

import "./noPatientInformation.vue?vue&type=style&index=0&id=2938ff05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2938ff05"]])

export default __exports__